<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="airRefundableObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">Refundability</p>
                    <p>Trigger for flights that are <span class="rule-config-variable" @click="isEdit = !isEdit">
                            {{ boolToStr(airRefundableObj.value) }}
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="airRefundableObj.isActive" v-model="airRefundableObj.isActive"
                        @input="airRefundable" :left-label="true">{{ airRefundableObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <AirRefundable :refundableVal="refundableVal" @emitData="getValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
    </div>
</template>
<script>
import AirRefundable from "../CommonRules/AirRefundable.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: { AirRefundable },
    data() {
        return {
            refundableVal: false,
            airRefundableObj: this.value
                ? this.value
                : {
                    name: "airRefundable",
                    isActive: false,
                    type: "air",
                    message: "Trigger for Refundable fares.",
                    value: false
                },
            isEdit: false,
            emitedValue: null
        };
    },
    methods: {
        airRefundable() {
            this.$emit("airRefundable", this.airRefundableObj);
        },
        getValue(val) {
            this.emitedValue = val;
        },
        saveCall() {
            this.isEdit = false;
            this.airRefundableObj.value = this.emitedValue;
        },
        boolToStr(bool){
            if(bool == true){
                return  'Non-Refundable'
            }else{
                return 'Refundable'
            }
        }
    },
    mounted() {
        this.airRefundableObj.type = "air";
        this.airRefundableObj.message = this.buildMessage;
        this.$emit("airRefundable", this.airRefundableObj);
    },
    computed: {
        typOfFlights() {
            if (this.airRefundableObj.value) {
                return 'Non-Refundable'
            } 
            return 'Refundable'
        }
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    const airfareProps = this.value;
                    this.airRefundableObj = airfareProps
                    this.refundableVal = airfareProps.value;
                    
                }
                this.airRefundableObj.type = "air";
                this.airRefundableObj.message = "Trigger if fare is " + this.boolToStr(this.airRefundableObj.value);
                this.$emit("airRefundable", this.airRefundableObj);

            },
            deep: true,
        },
    },
};
</script>
  